import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

@Pipe({
  name: 'format'
})
export class FormatPipe implements PipeTransform {

  public static transform(value: any, args?: any, sanitizer?: DomSanitizer): any {
    if (value) {
      if (typeof value === 'number') {
        return value;
      } else if (typeof value === 'boolean') {
        if (sanitizer) {
          if (value) {
            return sanitizer.bypassSecurityTrustHtml('<input type="checkbox" disabled checked>');
          } else {
            return sanitizer.bypassSecurityTrustHtml('<input type="checkbox" disabled>');
          }
        } else {
          return value;
        }
      } else {
        const dateString = value.match(/^\d{4}-\d{2}.\d{2}T\d{2}:\d{2}:\d{2}$/);
          if (dateString) {
            const date = new Date(Date.parse(dateString[0]));
            return date.toLocaleDateString();
          } else {
            return value;
        }
      }
    }
    return '-';
  }

  constructor (private sanitizer: DomSanitizer) {
  }

  transform(value: any, args?: any): any {
    return FormatPipe.transform(value, args, this.sanitizer);
    // return 'x';
    // if(value) {
    //   const dateString = value.match(/^\d{4}-\d{2}.\d{2}T\d{2}:\d{2}:\d{2}$/);
    //     if(dateString) {
    //       const date = new Date(Date.parse(dateString[0]));
    //       return date.toLocaleDateString();
    //     } else {
    //       return value;
    //     }
    // }
    // return '-';
  }



}
